export default __webpack_public_path__ + "static/media/DROP_DOWN.6dcbf80b.svg";